import { Component, type ErrorInfo, type ReactNode } from "react";

import { AI_WIDGET_FETCH_LOG_PREFIX } from "./constants";

type Props = {
  children: ReactNode;
  onError: () => void;
};

export class AiWidgetErrorBoundary extends Component<Props, { hasError: boolean }> {
  state = { hasError: false };

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(`${AI_WIDGET_FETCH_LOG_PREFIX} AiWidgetErrorBoundary caught:`, error, errorInfo);
    this.props.onError();
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
